import stickybits from 'stickybits';

initStickybits();
document.addEventListener('resize', function () {
  initStickybits();
});

function initStickybits() {
  stickybits('.stickybit', {
    stickyBitStickyOffset: 190,
  });
}
